import { Settings } from 'lucide-react';
import ComingSoon from './ComingSoon';

export default function MasterUserSettings() {
  return (
    <ComingSoon
      icon={Settings}
      title="Permissions"
      description="Master admin settings for managing user permissions and access controls"
    />
  );
}
